import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

const schema = yup.object({
  id: yup.string().nullable(),
  displayName: yup.string().required(),
  auditTimestamp: yup.date().nullable(),
  eventType: yup.string().nullable(),
  objectType: yup.string().nullable(),
  objectKey: yup.string().nullable(),
  auditUser: yup.string().nullable(),
  impersonator: yup.string().nullable(),
  correlationType: yup.string().nullable(),
  correlationId: yup.string().nullable(),
  details: yup.string().nullable(),
});

addKeyToFieldsRecursively(schema);

export default schema;
